(function ($) {
    "use strict";
    $(function () {
        if(!$(".episode__archive").length){
            return
        }


        $('#js-season-select').on('change', function(){
            const season = $(this).val();
            $.get_episodes_by_season(season, -1)
            
        })


    });
})(jQuery);